import instance from '@/api/index.js'
const urlPrefix = '/v1/'
export default {
  // 请假
  createAtt(params) {
    return instance({
      method: 'post',
      url: `${urlPrefix}attendance`,
      data: params
    })
  },
  adminCreate(params) {
    return instance({
      method: 'post',
      url: `${urlPrefix}attendance/admin_update`,
      data: params
    })
  },


  // 获取请假日历
  getAttCalendar(params) {
    return instance(
      {
        method: 'get',
        params: params,
        url: `${urlPrefix}attendance/calendar`,
      }
    )
  },
  // 编辑周报
  patchAtt(params, data) {
    return instance(
      {
        method: 'patch',
        params: params,
        data: data,
        url:`${urlPrefix}attendance`
      }
    )
  },

  // 删除请假
  deleteAtt(params) {
    return instance(
      {
        method: 'delete',
        params: params,
        url: `${urlPrefix}attendance`,
      }
    )
  },
  // 获取请假列表
  getAttList(params) {
    return instance(
      {
        method: 'get',
        params: params,
        url: `${urlPrefix}attendance/list`,
      }
    )
  },
  // 获取请假明细
  getAttStatus(params) {
    return instance(
      {
        method: 'get',
        params: params,
        url: `${urlPrefix}attendance/status`,
      }
    )
  },
  getComp(params) {
    return instance (
      {
        params: params,
        method: 'get',
        url:`${urlPrefix}comp/list`,
      }
    )
  },
  createComp(data) {
    return instance({
      method: 'post',
      url: `${urlPrefix}comp`,
      data: data
    })

  }
}
